
import { defineComponent, onMounted, ref } from "vue";
import { Dropzone } from "dropzone";

export default defineComponent({
  components: {},
  setup() {
    const dropRef = ref(null);
    const dropzone = ref<Dropzone>(null);
    const isAddedFile = ref(false);

    onMounted(async () => {
      if (dropRef.value !== null) {
        dropzone.value = new Dropzone(dropRef.value, {
          url: `${process.env.VUE_APP_API_URL}imgupload`,
          paramName: "file", // The name that will be used to transfer the file
          maxFiles: 1,
          maxFilesize: 10, // MB
          addRemoveLinks: true,
          acceptedFiles: ".png, .jpg, .jpeg",
          autoProcessQueue: false,
        });

        dropzone.value?.on("addedfile", function () {
          isAddedFile.value = true;
        });

        dropzone.value?.on("removedfile", function () {
          isAddedFile.value = false;
        });
      }
    });
    return {
      isAddedFile,
      dropRef,
      dropzone,
    };
  },
});
